<template>
    <div class="banner-box" :style="getBannerBoxStyle()">
        <div class="item" :style="getBannerItemStyle()">
            Banner
        </div>
    </div>
</template>

<script>
export default {
    name: "BannerView",
    props: ['obj'],
    methods: {

        getBannerBoxStyle() {
            const style = 'padding:' + + this.obj.banner_params.margin + 'px;'
            return style;
        },
        getBannerItemStyle() {
            const width = 375 - this.obj.banner_params.margin * 2
            const height = width * this.obj.banner_params.item_height_ratio / 100
            const style = 'width:' + width + 'px;' +
                'height:' + height + 'px;' +
                'line-height:' + height + 'px;' +
                'border-radius:' + this.obj.banner_params.corner_radius + 'px;'
            return style;
        }
    }
}
</script>

<style scoped lang="less">
.banner-box {
    width: 100%;
    text-align: center;
    color: white;
    box-sizing: border-box;

    .item {
        background-color: lightskyblue;
        text-align: center;
    }
}
</style>